export const TableIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 5H7C5.89543 5 5 5.89543 5 7V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V13V12V7C19 5.89543 18.1046 5 17 5ZM18 12V10H15V12H18ZM14 12V10H10V12H14ZM10 13H14V15H10V13ZM9 12V10H6V12H9ZM6 13V15H9V13H6ZM15 13H18V15H15V13ZM6 17V16H9V18H7C6.44772 18 6 17.5523 6 17ZM14 18H10V16H14V18ZM17 18H15V16H18V17C18 17.5523 17.5523 18 17 18ZM18 7V9H6V7C6 6.44772 6.44772 6 7 6H17C17.5523 6 18 6.44772 18 7Z"
        fill="#262E3D"
        fillOpacity="0.67"
      />
    </svg>
  );
};
